import { useContext, useState } from 'react';
import styles from './ReportOptions.module.css';
import AppContext from '../../AppContext';
import 'react-toggle/style.css';
import Toggle from 'react-toggle';
import { IoIosMenu } from 'react-icons/io';
import { reportViewLabel } from '../model/ReportView';
import { INDUSTRY_MEAN_LABEL } from '../model/ColumnLabels';
import { QUARTERLY_VIEW_MODE_OPTIONS, DEFAULT_QUARTERLY_VIEW_MODE, QUARTER_OPTIONS, YearsMode } from '../model/ViewMode';

function ReportOptions() {
  const {
    showBenchmark,
    setShowBenchmark,
    showIndustryMean,
    setShowIndustryMean,
    navIsOpen,
    setNavIsOpen,
    periodType,
    setPeriodType,
    quarterlyViewMode,
    setQuarterlyViewMode,
    yearsMode,
    setYearsMode,
    isRefreshing
  } = useContext(AppContext);
  const [scrollToTopVisible, setScrollToTopVisible] = useState(false);
  const { riskRepository } = useContext(AppContext);

  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  function toggleVisible() {
    if (window.scrollY > 500) {
      setScrollToTopVisible(true);
    } else {
      setScrollToTopVisible(false);
    }
  }

  window.addEventListener('scroll', toggleVisible);

  return (
    <div className={styles.container}>
      <div className={styles.options_container}>
        <div
          id="navigation-toggle"
          data-testid="navigation-toggle"
          className={styles.open_nav}
          onClick={() => setNavIsOpen(!navIsOpen)}>
          <IoIosMenu size={'2rem'} />
        </div>
        <label>Benchmark</label>
        <Toggle
          id="benchmark-toggle"
          data-testid="benchmark-toggle"
          className="naic-blue toggle"
          icons={false}
          defaultChecked={showBenchmark}
          onChange={() => setShowBenchmark((current: any) => !current)}
        />
        {!periodType && (
          <>
            <label style={{ marginLeft: '1rem' }}>{INDUSTRY_MEAN_LABEL}</label>
            <Toggle
              id="industry-mean-toggle"
              data-testid="industry-mean-toggle"
              className="naic-blue toggle"
              icons={false}
              defaultChecked={showIndustryMean}
              onChange={() => setShowIndustryMean((current: any) => !current)}
            />
          </>
        )}
        {periodType && (
          <div className={styles.quarterly_options}>
            <label htmlFor="quarter-select">Quarter</label>
            <select
              id="quarter-select"
              data-testid="quarter-select"
              className={styles.view_mode_select}
              value={periodType}
              onChange={(e) => {
                setPeriodType(e.target.value);
                sessionStorage.setItem('periodType', e.target.value);
              }}
            >
              {QUARTER_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
            <label htmlFor="view-mode-select">Quarterly Report</label>
            <select
              id="view-mode-select"
              data-testid="view-mode-select"
              className={styles.view_mode_select}
              value={quarterlyViewMode || DEFAULT_QUARTERLY_VIEW_MODE}
              onChange={(e) => {
                setQuarterlyViewMode(e.target.value);
                sessionStorage.setItem('viewMode', e.target.value);
              }}
            >
              {QUARTERLY_VIEW_MODE_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>
        )}
        {scrollToTopVisible && (
          <span id="scroll-to-top" onClick={scrollToTop} className={styles.back_to_top_button}>
            Back to top
          </span>
        )}
      </div>
      <h4 id="selected-report-view" data-testid="selected-report-view">
        {reportViewLabel(riskRepository)}
      </h4>
      <div className={styles.right_cluster}>
        {!periodType && (
          <div className={styles.years_toggle}>
            <label htmlFor="years-mode-toggle">10 Year View</label>
            <Toggle
              id="years-mode-toggle"
              data-testid="years-mode-toggle"
              className="naic-blue toggle"
              icons={false}
              checked={yearsMode === YearsMode.TEN}
              onChange={() => {
                const next = yearsMode === YearsMode.TEN ? YearsMode.FIVE : YearsMode.TEN;
                setYearsMode(next);
                sessionStorage.setItem('yearsMode', next);
              }}
            />
            {isRefreshing && (
              <span
                data-testid="years-mode-refreshing"
                aria-label="Refreshing report"
                className={styles.loading_indicator}>
                <span className={styles.inline_spinner} />
                <span className={styles.loading_text}>Loading...</span>
              </span>
            )}
          </div>
        )}
        <div className={styles.units}>Dollar values represented in thousands</div>
      </div>
    </div>
  );
}

export default ReportOptions;
